import React, { Component } from "react";
import "./portfolio.css";
import Projects from "../Project/Projects.js";
import Main from "../Main/Main.js";
import Pictures from "../components/Pictures.js";
import Welcome from "../Welcome/welcome.js";
import {
  NAV_BUTTONS,
  PAGE_VALUES,
  defaultProfile,
} from "../constants/const";
import { fetchProfile } from "../api/portfolio";

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: <Welcome onContinue={this.handleContinue} />,
      profileInfo: defaultProfile.profileInfo,
      socialLinks: defaultProfile.socialLinks,
    };
    this.updatePage = this.updatePage.bind(this);
  }

  componentDidMount() {
    fetchProfile().then((data) => {
      this.setState({
        profileInfo: data.profileInfo || defaultProfile.profileInfo,
        socialLinks: data.socialLinks || defaultProfile.socialLinks,
      });
    });
  }

  handleContinue = () => {
    this.setState({ page: <Main /> });
  };

  handleNavClick = (button) => {
    if (button.onClick) {
      button.onClick();
      return;
    }
    this.updatePage(button.value);
  };

  updatePage(value) {
    let temp = "";
    switch (value) {
      case PAGE_VALUES.PHOTO:
        temp = <Pictures />;
        break;
      case PAGE_VALUES.ME:
        temp = <Main />;
        break;
      case PAGE_VALUES.PROJECTS:
        temp = <Projects />;
        break;
      default:
        temp = <Welcome onContinue={this.handleContinue} />;
    }
    this.setState({ page: temp });
  }

  render() {
    const { page, profileInfo, socialLinks } = this.state;

    return (
      <div className="Portfolio">
        <div className="left">
          <div id="logo">
            <img id="logo-img" src="icons/picofme.jpg" alt="Logo" />
          </div>
          <div id="contacts" align="center">
            {socialLinks.map((link) => (
              <a key={link.name} href={link.url}>
                <img id="icons" src={link.icon} alt={link.name} />
              </a>
            ))}
          </div>
          <div id="copyright">
            <p align="center" id="bio">
              {profileInfo.alumniTag}
            </p>
            <p align="center">
              <span id="colour">{profileInfo.name}</span> @{" "}
              {profileInfo.copyrightYear}
            </p>
          </div>

          {page.type !== Welcome && (
            <div className="navbuttons">
              {NAV_BUTTONS.map((button) => (
                <div className="pad" key={button.value}>
                  <button
                    className="button-style"
                    value={button.value}
                    onClick={() => this.handleNavClick(button)}
                  >
                    {button.label}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="right">{this.state.page}</div>
      </div>
    );
  }
}

export default Portfolio;
